import { OrganizationType } from '@/shared/types'
import {
    FormActionsSlice,
    NavigationSlice,
    Step1Slice,
    Step2Slice,
    Step3Slice,
    Step4Slice,
    Step5Slice,
    Step6Slice,
    Step7Slice,
    Step8Slice,
} from './slices'

export interface CampaignCreationState
    extends FormActionsSlice,
        NavigationSlice,
        Step1Slice,
        Step2Slice,
        Step3Slice,
        Step4Slice,
        Step5Slice,
        Step6Slice,
        Step7Slice,
        Step8Slice {}

export const initialOrganization: OrganizationType = {
    type: '',
    name: '',
    inn: '',
    okved: '',
    isFinalAdvertiser: false,
}

export const initialState = {
    currentStep: 1,
    selectedTelegramPosts: [],
    telegramPosts: [],
    telegramLinkToAdvertize: '',
    telegramLinkToAdvertizeError: false,
    telegramPostToAdvertize: null,
    productService: '',
    customProductService: '',
    gender: '',
    schedule: '',
    locations: [],
    keywords: [],
    aiPosts: [],
    selectedAiPosts: {},
    organization: initialOrganization,
    topupAmount: 5000,
    budget: 3000,
}
